export default __webpack_public_path__ + "static/media/icon-webstorm.81d3d3a4.svg";